import type { CSSProperties } from 'react';
import { cn } from './cn.js';

export interface IconProps {
  /** Material Symbols ligature, e.g. "home", "dashboard", "settings", "translate". */
  name: string;
  size?: number;
  fill?: boolean;
  className?: string;
  style?: CSSProperties;
}

/**
 * Material Symbols Rounded glyph. The font is loaded by styles.css; `name` is the ligature, so
 * any of the ~3000 symbols works without adding a dependency.
 */
export function Icon({ name, size = 24, fill = false, className, style }: IconProps) {
  return (
    <span
      className={cn('material-symbols-rounded', className)}
      aria-hidden="true"
      style={{
        fontSize: size,
        fontVariationSettings: `'FILL' ${fill ? 1 : 0}, 'opsz' ${size}`,
        ...style,
      }}
    >
      {name}
    </span>
  );
}
